<template>
     <div v-if="displayTuto()" :class="V ? 'cliqueV' : 'clique'">
			<div :class="V ? 'arrowUpV' : 'arrowUp'">&nbsp;</div>
		</div>
</template>
<style scoped>
.arrowUpV {
		background-image: url("../assets/arrowDown.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 40px;
        width: 40px;        
        margin-top: -40px;
		margin-left: 25px;
		-webkit-animation-name: animV;
		-webkit-animation-duration: 1s;
		-webkit-animation-iteration-count: infinite;
		-moz-animation-name: animV;
		-moz-animation-duration: 1s;
		-moz-animation-iteration-count: infinite;
		animation-name: animV;
		animation-duration: 1s;
		animation-iteration-count: infinite;
			z-index: 2000;
	}
	@-webkit-keyframes animV {
		0% {
			 visibility: visible;
		}
		50% {
		
			visibility: hidden;
		}
		100% {
		
			visibility: hidden;
		}
	}
	@-moz-keyframes animV {
		0% {
			 visibility: visible;
		}
		50% {
		
			visibility: hidden;
		}
		100% {
		
			visibility: hidden;
		}
	}
	@keyframes 'animV' {
		0% {
			 visibility: visible;
		}
		50% {
		
			visibility: hidden;
		}
		100% {
		
			visibility: hidden;
		}
	}
.arrowUp {
		background-image: url("../assets/arrowUp.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 50px;
        width: 50px;        
        display: inline-block;
		position: absolute;
		-webkit-animation-name: anim;
		-webkit-animation-duration: 1s;
		-webkit-animation-iteration-count: infinite;
		-moz-animation-name: anim;
		-moz-animation-duration: 1s;
		-moz-animation-iteration-count: infinite;
		animation-name: anim;
		animation-duration: 1s;
		animation-iteration-count: infinite;
			z-index: 5000;
	}
	@-webkit-keyframes anim {
		0% {
			top: 30px;
			left: 0px;
		}
		50% {
			top: 45px;
			left: 0px;
		}
		100% {
			top: 30px;
			left: 0px;
		}
	}
	@-moz-keyframes anim {
		0% {
			top: 30px;
			left: 0px;
		}
		50% {
			top: 45px;
			left: 0px;
		}
		100% {
			top: 30px;
			left: 0px;
		}
	}
	@keyframes 'anim' {
		0% {
			top: 30px;
			left: 0px;
		}
		50% {
			top: 45px;
			left: 0px;
		}
		100% {
			top: 30px;
			left: 0px;
		}
	}
	.clique {
		width: 0px;
		border-radius: 20px;
		z-index: 3000;
		
	}
	
</style>
<script>
export default {
    props: ["id","label", "V"],
    methods: {
        displayTuto() {
				var demo = this.$store.getters.getDemo;
				if (demo.active && demo.tutoriel != null) {
					var id, byId;
					if (typeof(this.id)!="undefined") {
						id = this.id;
						byId = true;
					}
					else {
						id = this.label;
						byId = false;
					}
					return this.$arrowTuto(id, byId, this.$route.name);
				}
				else
					return false;
			}
    }
}
</script>